'use client';
import { Phone } from '@mui/icons-material';
import { Button, Typography, useTheme } from '@mui/material';

interface ContactCallButtonProps {
  contactUsPrompt?: string;
  contactUsNumber?: string;
}

export function ContactCallButton({
  contactUsPrompt = 'Prefer to chat? Give us a call',
  contactUsNumber = '1300 668 843',
}: ContactCallButtonProps) {
  const theme = useTheme();

  const formattedNumber = contactUsNumber.replaceAll(' ', '');

  return (
    <Typography
      sx={{
        fontSize: theme.typography.body1.fontSize,
      }}
    >
      {contactUsPrompt}
      <br />
      <Button
        variant="contained"
        href={`tel:${formattedNumber}`}
        startIcon={<Phone />}
        sx={{
          marginTop: theme.spacing(3),
          fontSize: theme.typography.h5.fontSize,
          '*': {
            whiteSpace: 'nowrap',
          },
          svg: {
            path: {
              stroke: 'currentColor',
              strokeWidth: 2,
            },
          },
        }}
      >
        Call {contactUsNumber}
      </Button>
    </Typography>
  );
}
